import React from "react";
import Card from "./RecipeView/Card";
import ListItem from "./RecipeView/ListItem";

export default function RecipeList({ recipes, type }) {

	if (recipes?.length === 0) {
		return <div><br />Sorry, no recipes match your search criteria</div>
	}

	switch (type) {
		case "list":
			return (
				<div>
					{recipes.map((recipe) => (
						<ListItem recipe={recipe} key={recipe.id} />
					))}
				</div>
			);
		default:
			return (
				<div className="recipe-list">
					<div style={{ columns: "6 200px", columnGap: "1rem" }}>
						{recipes.map((recipe) => (
							<Card recipe={recipe} key={recipe.id} />
						))}
					</div>
				</div>
			);
	}
}
